import { ConfirmDialog } from '../../components';

import type { NoTherapyConfirmDialogProps } from './types';

export default function NoTherapyConfirmDialog({
  open,
  hasSavedTherapies,
  confirmLoading,
  onClose,
  onConfirm,
}: NoTherapyConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      title={hasSavedTherapies ? 'Remove all therapies?' : 'Confirm no historical therapy?'}
      message={
        hasSavedTherapies ? (
          <>
            Selecting "No historical therapy" will permanently delete all therapies you've entered.
            <br />
            This action can't be undone.
          </>
        ) : (
          'This marks that the client has no historical therapy.'
        )
      }
      confirmLabel={hasSavedTherapies ? 'Remove all' : 'Confirm'}
      confirmLoading={confirmLoading}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
